import { Card, CardContent } from '@/components/Card/Card';
import { formatDate } from '@/helpers/dateHelpers/dateHelpers';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { TransactionListItemType } from '@/api/v1/organization/contracts/getTransactionsApi';
import { getTransactionDetailsPath } from '../pages/TransactionDetailsPage/path/path';
import { useStatefulNavigation } from '@/hooks/useStatefulNavigation';
import { useGetSearchParams } from '@/hooks/useGetSearchParams';
import { FiltersSearchParams } from '@/bundle/_OrgAdmin/hooks/useFilterSearch';
import { createSearchParams } from '@/hooks/useReplaceSearchParams';

type TransactionsListType = {
  list: TransactionListItemType[];
};

export const TransactionsList = ({ list }: TransactionsListType) => {
  const { navigateFrom } = useStatefulNavigation();
  const searchParams = useGetSearchParams<{ name?: string } & FiltersSearchParams>();

  const navigateToDetails = (id: string) => {
    amplitudeService.logEvent(AMPLITUDE_EVENTS.TransactionViewDetails);

    const hasFilterSearch = !!searchParams.name && searchParams.types?.length > 0;
    const searchFilterParams = hasFilterSearch
      ? createSearchParams({ name: searchParams.name, types: searchParams.types })
      : null;

    navigateFrom({ pathname: getTransactionDetailsPath(id), search: searchFilterParams });
  };

  return (
    <>
      {list.map((item) => {
        const { name, date_created, expected_close_date, created_by, number_of_wires, id } = item;
        const { email } = created_by;

        return (
          <Card key={id} title={name} header={name} onClick={() => navigateToDetails(id)}>
            <CardContent name='Creation Date'>{formatDate(date_created)}</CardContent>
            <CardContent name='Expected Closing Date'>{formatDate(expected_close_date)}</CardContent>
            <CardContent name='Created by' ratio={2}>
              {email}
            </CardContent>
            <CardContent name='Number of wires'>{number_of_wires}</CardContent>
          </Card>
        );
      })}
    </>
  );
};
